import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import { Grid, Typography, CircularProgress, Tabs, Tab, Modal, Button } from '@mui/material';

import BalanceGridActive from 'js/containers/Balance/BalanceGridActive';
import BalanceGridInactive from 'js/containers/Balance/BalanceGridInactive';

import { trackEventMatomoVisit, trackEventMatomo } from 'js/library/utils/helpers';
import { useCurrentUserInfo } from 'js/library/services/currentUserInfo';
import { getWallet_v1 } from 'js/library/utils/API/getWallet_v1.js';
// import { getBalance } from 'js/library/utils/API/getBalance';
import cfac22 from 'js/library/utils/cfac22';

import StatementModal from 'js/containers/Balance/StatementModal';

export default function Wallet() {
  const { userInfo, loading: userInfoLoading } = useCurrentUserInfo();

  const [tab, setTab] = useState(0);
  const [openStatement, setOpenStatement] = useState(false);
  const [activeCoupons, setActiveCoupons] = useState(null);
  const [inactiveCoupons, setInactiveCoupons] = useState(null);
  const isGuest = !userInfo || userInfo.triiboId?.includes('guest');

  useEffect(() => {
    if (!userInfo) return;

    trackEventMatomoVisit('Carteira');
    document.title = 'Carteira';

    if (!isGuest) {
      getWallet_v1(userInfo.uId, userInfo.triiboId).then((walletReceived) => {
        if (walletReceived != null) {
          const activeCouponsAux = [];
          const inactiveCouponsAux = [];

          if (walletReceived.coupons !== null) {
            Object.entries(walletReceived.coupons).forEach((coupon) => {
              const item = coupon[1];
              item.key = coupon[0];

              if (
                (item.status === 'enviado' || item.state === 'ongoing') &&
                item.dueDate >= Date.now()
              ) {
                return activeCoupons.push(item);
              } else {
                inactiveCouponsAux.push(item);
              }
            });
          }

          setActiveCoupons(activeCouponsAux);
          setInactiveCoupons(inactiveCouponsAux);
        }
      });
    }
  }, [isGuest, userInfo]);

  const handleChange = (_, newValue) => {
    setTab(newValue);
  };

  if (userInfoLoading) {
    return <CircularProgress />;
  }

  if (isGuest) {
    return <Navigate to="/" />;
  } else {
    return (
      <div className="paper-container">
        <div style={{ width: '100%' }}>
          <Modal
            sx={{ zIndex: 9999999 }}
            open={openStatement}
            onClose={() => setOpenStatement(false)}
          >
            <div>
              <StatementModal
                openStatement={openStatement}
                setOpenStatement={setOpenStatement}
                userInfo={userInfo}
              />
            </div>
          </Modal>
          <Grid
            container
            sx={{
              backgroundColor: '#fff',
              width: '100%',
              maxWidth: 1600,
              margin: '0 auto',
              display: 'flex',
              justifyContent: 'center',
              padding: {
                xs: '10px',
                md: '20px',
              },
            }}
          >
            <Grid size={{ xs: false, sm: 5 }}></Grid>
            <Grid size={{ xs: 12, sm: 7 }}>
              <Button
                onClick={() => setOpenStatement(true)}
                variant="contained"
                sx={{
                  width: '100%',
                  margin: '15px 0px',
                  color: '#fff',
                  background: '#6E3296',
                }}
              >
                Abrir extrato de pontos
              </Button>
            </Grid>
            <Grid size={{ xs: 12 }} style={{ width: '100%' }}>
              {activeCoupons === null || inactiveCoupons === null ? (
                <div style={{ textAlign: 'center' }}>
                  <CircularProgress
                    style={{
                      color: '#000',
                      padding: '150px 20px',
                      boxSizing: 'content-box',
                    }}
                  />
                </div>
              ) : (
                <div>
                  <Tabs
                    value={tab}
                    onChange={handleChange}
                    style={{
                      padding: '0 12px',
                      backgroundColor: '#fff',
                    }}
                  >
                    <Tab
                      onClick={() =>
                        trackEventMatomo('Carteira', 'click', 'botao', 'Cupons ativos')
                      }
                      style={{
                        textTransform: 'none',
                        fontWeight: 'bolder',
                      }}
                      label="Cupons ativos"
                    />
                    <Tab
                      onClick={() =>
                        trackEventMatomo('Carteira', 'click', 'botao', 'Cupons inativos')
                      }
                      style={{
                        textTransform: 'none',
                        fontWeight: 'bolder',
                      }}
                      label="Cupons inativos"
                    />
                  </Tabs>

                  {tab === 0 ? (
                    activeCoupons.length === 0 ? (
                      <Typography variant="h6" color="secondary" style={{ paddingTop: '5px' }}>
                        Você não possui cupons ativos.
                      </Typography>
                    ) : (
                      <BalanceGridActive coupons={activeCoupons} />
                    )
                  ) : inactiveCoupons.length === 0 ? (
                    <Typography variant="h6" color="secondary" style={{ paddingTop: '5px' }}>
                      Você não possui cupons inativos.
                    </Typography>
                  ) : (
                    <BalanceGridInactive coupons={inactiveCoupons} />
                  )}
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

